// @ts-ignore
import TurndownService from 'turndown';
import rules from './textileRules';

const createTurndownService = () => {
  const turndownService = new TurndownService();

  Object.entries(rules).forEach(([key, rule]) => {
    turndownService.addRule(key, rule as TurndownService.Rule);
  });

  return turndownService;
};

const htmlToTextile = (html: string | null | undefined) => {
  if (!html) {
    return html;
  }

  const turndownService = createTurndownService();

  return turndownService.turndown(html);
};

export default htmlToTextile;
